import { render, staticRenderFns } from "./ChildTable.vue?vue&type=template&id=54ebf9f7"
import script from "./ChildTable.vue?vue&type=script&lang=js"
export * from "./ChildTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports